export const FirebaseAnalyticsMock = (firebaseApp: firebase.default.app.App) => ({
	app: firebaseApp,
	logEvent: () => undefined,
	setCurrentScreen: () => undefined,
	setUserId: () => undefined,
	setUserProperties: () => undefined,
	setAnalyticsCollectionEnabled: () => undefined,
});
